import { NextPageWithLayout } from "./_app"
import { Metadata } from "@/components/Metadata"
import { CommonLayout } from "@/components/Layouts"
import dynamic from "next/dynamic"

const QuestUI = dynamic(() => import("@/components/Quest"), {
  ssr: false,
})

const QuestPage: NextPageWithLayout = () => {
  return (
    <>
      <Metadata title="GAIA | Quests" description="GAIA" type="website" />
      <QuestUI />
    </>
  )
}

QuestPage.getLayout = page => <CommonLayout>{page}</CommonLayout>

export default QuestPage
